import * as types from '../mutation-types'

const state = {
    logData: {},
}

const getters = {
    getLogFor: state => state.logData,
}

const actions = {
    setActionLogType({ commit, state }, data) {
        // console.log('called',data);
        commit(types.SET_VACATION_LOG_TYPE, {
            'data': data
        })
    },
}
const mutations = {

    [types.SET_VACATION_LOG_TYPE](state, { data }) {
        state.logData = data;
    },

}
export default {
    state,
    getters,
    actions,
    mutations

}
